"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[603,2721,6800],{

/***/ 603:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isVisible)
/* harmony export */ });
function isVisible(el) {
  // Check if element has dimensions (accounts for parent visibility too)
  if (el.offsetWidth === 0 && el.offsetHeight === 0) {
    return false
  }

  // Also check computed styles for visibility and opacity
  const style = window.getComputedStyle(el)
  return style.visibility !== 'hidden' && style.opacity !== '0'
}


/***/ }),

/***/ 2721:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MegaMenuNew)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5730);
/* harmony import */ var _utilities_set_height__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6800);




function MegaMenuNew({ wrapper }) {
  const $megaMenu = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper),
    $mobileNavToggle = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-open-mobile-menu]'),
    $desktopNavToggle = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-open-desktop-menu]'),
    $announcementBarCollapseTrigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-announcement-bar-collapse-trigger]'),
    $mobileMenu = $megaMenu.find('[data-mobile-mega-menu]'),
    $desktopMenu = $megaMenu.find('[data-desktop-mega-menu]'),
    $mobileMenuWrapper = $megaMenu.find('[data-mobile-mega-menu-wrapper]'),
    $desktopMenuWrapper = $megaMenu.find('[data-desktop-mega-menu-wrapper]'),
    $submenuContainer = $megaMenu.find('[data-submenu-container]'),
    $submenuTrigger = $megaMenu.find('[data-submenu-trigger]'),
    $submenu = $megaMenu.find('[data-submenu]'),
    $nestedSubmenuTrigger = $megaMenu.find('[data-nested-submenu-trigger]'),
    $nestedSubmenu = $megaMenu.find('[data-nested-submenu]'),
    $nestedSubmenuBack = $megaMenu.find('[data-nested-submenu-back]'),
    $desktopPolaroidContainer = $megaMenu.find('[data-linklist-polaroid]'),
    $desktopSubmenuTrigger = $megaMenu.find('[data-desktop-submenu-trigger]'),
    $closeMobileNav = $megaMenu.find('[data-close-mobile-menu]'),
    $closeDesktopNav = $megaMenu.find('[data-close-desktop-menu]'),
    $overlay = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).find('[data-mega-menu-overlay]'),
    $headerCountdown = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).find('[data-header-countdown]')

  ;(function init() {
    if (!$megaMenu.length) return
    setTabindex()
    initEventListeners()
  })()

  function setTabindex() {
    $submenu.find('button, a').removeAttr('tabindex')
    $nestedSubmenu.find('button, a').removeAttr('tabindex')
    $desktopPolaroidContainer.find('button, a').removeAttr('tabindex')
    $submenu.not('.on').find('button, a').attr('tabindex', '-1')
    $nestedSubmenu.not('.on').find('button, a').attr('tabindex', '-1')
    $desktopPolaroidContainer.not('.on').find('button, a').attr('tabindex', '-1')
  }

  function initEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor($mobileNavToggle, function ($el) {
      $el.on('click', toggleMegaMenuMobile)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor($desktopNavToggle, function ($el) {
      $el.on('click', toggleMegaMenuDesktop)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor($closeMobileNav, function ($el) {
      $el.on('click', toggleMegaMenuMobile)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor($closeDesktopNav, function ($el) {
      $el.on('click', toggleMegaMenuDesktop)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor($desktopSubmenuTrigger, function ($el) {
      $el.on('click', openSubmenuFromDesktopLink)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor($submenuTrigger, function ($el) {
      $el.on('click', toggleSubmenu)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor($nestedSubmenuTrigger, function ($el) {
      $el.on('click', openNestedSubmenu)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor($nestedSubmenuBack, function ($el) {
      $el.on('click', closeNestedSubmenu)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor($overlay, function ($el) {
      $el.on('click', jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).width() < 1024 ? toggleMegaMenuMobile : toggleMegaMenuDesktop)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('keydown', listenForEscape)

    // enlarged search icon fix
    function enableAlgoliaSearch() {
      const $algoliaSearchTrigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-algolia-search-trigger]')
      if ($algoliaSearchTrigger.length) {
        setTimeout(() => {
          $algoliaSearchTrigger.removeAttr('disabled')
        }, 2000)
      }
    }

    // Check if document is already loaded (handles Firefox cache issue)
    if (document.readyState === 'complete') {
      enableAlgoliaSearch()
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('load', enableAlgoliaSearch)
    }
  }

  function listenForEscape(e) {
    if (e.key === 'Escape' && $mobileNavToggle.hasClass('on')) {
      toggleMegaMenuMobile(e)
      toggleMegaMenuDesktop(e)
    }
  }

  function toggleMegaMenuMobile(e) {
    e.preventDefault()

    if ($mobileNavToggle.hasClass('on')) {
      closeMegaMenu($closeMobileNav)
    } else {
      openMegaMenu($mobileNavToggle)
    }
  }

  function toggleMegaMenuDesktop(e) {
    e.preventDefault()

    if ($desktopNavToggle.hasClass('on')) {
      closeMegaMenu($closeDesktopNav)
    } else {
      openMegaMenu($desktopNavToggle)
    }
  }

  function openSubmenuFromDesktopLink(e) {
    e.preventDefault()
    const desktopSubmenuLabel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget).data('desktop-submenu-trigger')
    const $desktopSubmenuTarget = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-submenu-trigger="${desktopSubmenuLabel}"]`)

    !$desktopNavToggle.hasClass('on') ? openMegaMenu($desktopNavToggle) : ''

    $desktopSubmenuTarget.trigger('click')
  }

  function openMegaMenu($button) {
    if ($announcementBarCollapseTrigger.length && $announcementBarCollapseTrigger.hasClass('on')) {
      $announcementBarCollapseTrigger.trigger('click')
    }

    if ($headerCountdown.length) {
      $headerCountdown.hide()
      $headerCountdown.attr('aria-hidden', true)
      ;(0,_utilities_set_height__WEBPACK_IMPORTED_MODULE_2__["default"])({ selector: '.header-section', variable: 'mainNavHeight', property: '--main-nav-height' })
      ;(0,_utilities_set_height__WEBPACK_IMPORTED_MODULE_2__["default"])({ selector: '.header-section', variable: 'foldHeight', property: '--fold-height', isFold: true })
    }
    $overlay.fadeIn(300)
    $button.addClass('on').attr('aria-expanded', 'true')
    // make sure gorgias chat button is behind nav when open
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('#chat-button').addClass('!z-10')
    // hide attentive popup when nav is open
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('#attentive_overlay').addClass('!hidden')
    if ($button.data('open-mobile-menu')) {
      $mobileMenu.addClass('on')
      $mobileMenuWrapper.addClass('block').removeClass('hidden')
      $closeMobileNav.addClass('on').attr('aria-expanded', 'true')
      setTimeout(() => {
        $mobileMenu.addClass('z-50')
      }, 300)
    } else if ($button.data('open-desktop-menu')) {
      $desktopMenu.addClass('on')
      $desktopMenuWrapper.addClass('flex').removeClass('hidden')
      $closeDesktopNav.addClass('on').attr('aria-expanded', 'true')
      setTimeout(() => {
        $desktopMenu.addClass('z-50')
      }, 300)
    }
    (0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({ lock: true })
  }

  function closeMegaMenu($button) {
    $overlay.fadeOut(300)
    $button.removeClass('on').attr('aria-expanded', 'false')
    // make sure gorgias chat button is behind nav when open
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('#chat-button').removeClass('!z-10')
    // hide attentive popup when nav is open
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('#attentive_overlay').removeClass('!hidden')
    if ($button.data('open-mobile-menu') || $button.data('close-mobile-menu')) {
      $mobileMenu.removeClass('z-50').removeClass('on')
      $mobileNavToggle.removeClass('on').attr('aria-expanded', 'false')
      setTimeout(() => {
        $mobileMenuWrapper.removeClass('block').addClass('hidden')
      }, 300)
    } else if ($button.data('open-desktop-menu') || $button.data('close-desktop-menu')) {
      $desktopMenu.removeClass('z-50')
      setTimeout(() => {
        $desktopMenu.removeClass('on')
      }, 100)
      $desktopNavToggle.removeClass('on').attr('aria-expanded', 'false')
      setTimeout(() => {
        $desktopMenuWrapper.removeClass('flex').addClass('hidden')
      }, 300)
    }
    (0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({ lock: false })
  }

  function toggleSubmenu(e) {
    e.preventDefault()
    $submenuTrigger.removeClass('on').attr('aria-current', 'false')
    $submenu.removeClass('on')
    $nestedSubmenuTrigger.removeClass('on').attr('aria-current', 'false')
    const submenuLabel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget).data('submenu-trigger')
    const $submenuTarget =
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).width() < 1024
        ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-mobile-mega-menu] [data-submenu="${submenuLabel}"]`)
        : jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-desktop-mega-menu] [data-submenu="${submenuLabel}"]`)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget).addClass('on').attr('aria-current', 'true')
    $submenuTarget.addClass('on')
    // hide all desktop polaroids
    $desktopPolaroidContainer.removeClass('on')

    // show desktop polaroid
    const polaroidLabel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget).data('linklist-polaroid-trigger')
    const $polaroidTarget = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-linklist-polaroid="${polaroidLabel}"]`)
    $polaroidTarget.addClass('on')

    // reset submenu container and open nested submenus
    $submenuContainer.removeClass('on')
    $nestedSubmenu.removeClass('on')

    // wait for transition animations to finish before updating aria-hidden and focusing on first focusable element
    setTimeout(() => {
      $submenu.attr('aria-hidden', 'true')
      $submenuTarget.attr('aria-hidden', 'false')
      $desktopPolaroidContainer.attr('aria-hidden', 'true')
      $polaroidTarget.attr('aria-hidden', 'false')
      $nestedSubmenu.attr('aria-hidden', 'true')
      $submenuTarget.findFocusable().filter(':visible').first().trigger('focus')
    }, 300)

    setTabindex()
  }

  let $nestedSubmenuTriggerParent

  function openNestedSubmenu(e) {
    e.preventDefault()
    $nestedSubmenuTrigger.removeClass('on').attr('aria-current', 'false')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget).addClass('on').attr('aria-current', 'true')
    // hide all nested submenus
    $nestedSubmenu.removeClass('on')
    $submenuContainer.addClass('on')
    $nestedSubmenuTriggerParent = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget).closest('[data-submenu]')
    const desktopSubmenuList = $nestedSubmenuTriggerParent.data('desktop-submenu-list')
    const nestedSubmenuLabel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget).data('nested-submenu-trigger')
    const $nestedSubmenuTarget =
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).width() < 1024
        ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-mobile-mega-menu] [data-nested-submenu="${nestedSubmenuLabel}"]`)
        : jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-desktop-mega-menu] [data-nested-submenu="${nestedSubmenuLabel}"]`)
    $nestedSubmenuTarget.first().addClass('on')

    !desktopSubmenuList ? $nestedSubmenuTriggerParent.removeClass('on') : ''

    // hide all desktop polaroids
    $desktopPolaroidContainer.removeClass('on')

    // wait for transition animations to finish before setting aria-hidden and focusing on first focusable element
    setTimeout(() => {
      $desktopPolaroidContainer.attr('aria-hidden', 'true')
      $nestedSubmenu.attr('aria-hidden', 'true')
      !desktopSubmenuList ? $nestedSubmenuTriggerParent.attr('aria-hidden', 'true') : ''
      $nestedSubmenuTarget.attr('aria-hidden', 'false').findFocusable().filter(':visible').first().trigger('focus')
    }, 300)

    scrollToTop()
    setTabindex()
  }

  function closeNestedSubmenu(e) {
    e.preventDefault()
    $nestedSubmenuTrigger.removeClass('on').attr('aria-current', 'false')
    $submenuContainer.removeClass('on')
    const nestedSubmenuTarget = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget).parent().data('nested-submenu')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-nested-submenu="${nestedSubmenuTarget}"]`).removeClass('on')
    $nestedSubmenuTriggerParent.addClass('on')

    // wait for transition animations to finish before setting aria-hidden and focusing on first focusable element
    setTimeout(() => {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-nested-submenu="${nestedSubmenuTarget}"]`).attr('aria-hidden', 'true')
      $nestedSubmenuTriggerParent
        .attr('aria-hidden', 'false')
        .findFocusable()
        .filter(':visible')
        .first()
        .trigger('focus')
    }, 300)

    scrollToTop()
    setTabindex()
  }

  function scrollToTop() {
    // scroll to top of menu when opening/closing submenus
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('header')[0].scrollIntoView({ behavior: 'smooth' })
    $submenuContainer.parent().parent().animate({ scrollTop: 0 }, 300)
  }
}


/***/ }),

/***/ 5730:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ toggleScroll)
/* harmony export */ });
/**
 * * Applies scroll locked styles to the docuemnt body
 *
 * @param  {Object[]} elements - A list of jQuery objects
 * @returns {boolean} Whether the elements were found on the DOM
 */

function toggleScroll({ lock } = { lock: true }) {
  if (lock) {
    lockScroll()
  } else if (document.body.style.overflow === 'hidden') {
    unlockScroll()
  }
}

function lockScroll() {
  const scrollPosition = window.scrollY

  document.body.style.overflow = 'hidden'
  document.body.style.position = 'fixed'
  document.body.style.top = `-${scrollPosition}px`
  document.body.style.width = '100%'
}

function unlockScroll() {
  const scrollPosition = parseInt(document.body.style.top) * -1

  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('position')
  document.body.style.removeProperty('top')
  document.body.style.removeProperty('width')

  if (!scrollPosition) return
  window.scrollTo({ top: scrollPosition, behavior: 'instant' })
}


/***/ }),

/***/ 6800:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ setHeight)
/* harmony export */ });
/* harmony import */ var _is_visible__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(603);


function setHeight({ selector, variable, property, isFold, offset = 0 }) {
  // Find all elements matching the selector
  const elements = document.querySelectorAll(selector)
  // Find the first visible element
  let element = null

  for (const el of elements) {
    // Check if element is visible (not display: none and in the DOM)
    if ((0,_is_visible__WEBPACK_IMPORTED_MODULE_0__["default"])(el)) {
      element = el
      break
    }
  }

  if (element !== null) {
    window.config[variable] = element.offsetHeight
  } else {
    window.config[variable] = 0
  }

  if (isFold) {
    document.body.style.setProperty(property, `calc(100dvh - ${window.config[variable]}px)`)
  } else {
    document.body.style.setProperty(property, `${window.config[variable] + offset}px`)
  }
}


/***/ })

}]);